/**
 * File de modération unique (lot 5) : lecture de `GET /moderation/a-traiter`.
 * Les actions passent par les services de chaque source (messagerie,
 * signalements IA, signalements d'exercices).
 */
import { ADMIN_URLS } from '../../../config/adminApi';
import { AppEnvironment } from '../../../config/environment';
import { createApiClient, withEnv } from '../../../lib/http';

const api = createApiClient();

export type TypeElement = 'relire' | 'detresse' | 'incident' | 'ia' | 'exercice';
export type Gravite = 'haute' | 'moyenne' | 'basse';

/** Un élément de la file, sous la forme commune servie par le serveur. */
export interface ElementATraiter {
  id: string;
  type: TypeElement;
  gravite: Gravite;
  date: string | null;
  resume: string;
  personneVisee: string | null;
  auteur: string | null;
  cible: { conversationId?: string | null; messageId?: string | null; bookExerciseId?: string | null };
  /** Champs propres à la source (motifs, extrait, pièce, statut…). */
  details: Record<string, unknown>;
}

/** Réponse de la file : éléments triés, compteurs, sources illisibles. */
export interface FileATraiter {
  data: ElementATraiter[];
  compteurs: { total: number; parType: Partial<Record<TypeElement, number>> };
  erreurs: Partial<Record<TypeElement, string>>;
}

/** Lit la file de l'environnement affiché. */
export const lireFileATraiter = async (env: AppEnvironment): Promise<FileATraiter> => {
  const response = await api.get<FileATraiter>(`${ADMIN_URLS.moderation}/a-traiter`, withEnv(env));
  return response.data;
};
